export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readCount: number;
  commentCount: number;
  likeCount: number;
  isHot: boolean;
  isFeatured: boolean;
  tags: string[];
}

export const categories = [
  { name: '网红塌房', slug: 'wanghong-tafang', icon: 'ri-user-unfollow-line', description: '网红翻车现场直击，塌房事件第一时间曝光' },
  { name: '黑料大瓜', slug: 'heiliao-dagua', icon: 'ri-file-warning-line', description: '深度挖掘不为人知的黑料内幕，吃瓜不停歇' },
  { name: '聊天记录', slug: 'liaotian-jilu', icon: 'ri-chat-smile-2-line', description: '博主私密聊天记录曝光，真相浮出水面' },
  { name: '反差视频', slug: 'fancha-shipin', icon: 'ri-movie-2-line', description: '人前人后大不同，反差视频震撼首发' },
  { name: '每日爆料', slug: 'meiri-baoliao', icon: 'ri-flashlight-line', description: '每日最新爆料汇总，不错过任何一个大瓜' },
  { name: '实时追踪', slug: 'shishi-zhuizong', icon: 'ri-radar-line', description: '热点事件实时追踪，持续更新最新进展' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '千万粉丝网红"甜心baby"人设崩塌，私密视频流出引发全网震动',
    excerpt: '拥有超过两千万粉丝的知名网红"甜心baby"近日被爆出多段私密视频，与其一直以来塑造的清纯人设形成强烈反差，粉丝纷纷表示无法接受。',
    content: '',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20with%20a%20smartphone%20screen%20displaying%20shocking%20social%20media%20drama%20content%2C%20warm%20dramatic%20lighting%20with%20deep%20shadows%2C%20cinematic%20composition%2C%20mysterious%20atmosphere%2C%20modern%20digital%20age%20aesthetic%2C%20warm%20amber%20and%20deep%20red%20color%20tones%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20grainy%20texture&width=800&height=480&seq=article-cover-01&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-07-06',
    readCount: 1285000,
    commentCount: 32580,
    likeCount: 89200,
    isHot: true,
    isFeatured: true,
    tags: ['网红塌房', '甜心baby', '人设崩塌', '私密视频'],
  },
  {
    id: 'article-2',
    title: '知名美食博主被曝长期使用过期食材，后厨卫生状况触目惊心',
    excerpt: '以"精致美食"走红的美食博主，近日被前员工爆料其拍摄使用的食材多为过期产品，后厨环境更是脏乱不堪，与其镜头前展示的干净整洁形成巨大反差。',
    content: '',
    category: '黑料大瓜',
    categorySlug: 'heiliao-dagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20moody%20kitchen%20scene%20with%20dramatic%20lighting%2C%20expired%20food%20ingredients%20on%20a%20dirty%20counter%2C%20cinematic%20atmosphere%2C%20contrast%20between%20beautiful%20and%20ugly%2C%20warm%20amber%20tones%20with%20deep%20shadows%2C%20editorial%20photography%2C%20mysterious%20and%20revealing%20mood&width=800&height=480&seq=article-cover-02&orientation=landscape',
    author: '暗访调查组',
    publishDate: '2026-07-05',
    readCount: 956000,
    commentCount: 28700,
    likeCount: 65400,
    isHot: true,
    isFeatured: false,
    tags: ['黑料大瓜', '美食博主', '过期食材', '卫生问题'],
  },
  {
    id: 'article-3',
    title: '某知名情侣博主分手内幕曝光，聊天记录揭示惊天骗局',
    excerpt: '曾经被誉为"模范情侣"的知名博主组合，近日被爆出分手内幕。从流出的聊天记录来看，两人关系早在半年前就已破裂，之后的所有恩爱视频均为剧本演出。',
    content: '',
    category: '聊天记录',
    categorySlug: 'liaotian-jilu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20showing%20intense%20chat%20messages%20in%20Chinese%2C%20dramatic%20warm%20lighting%2C%20dark%20moody%20background%2C%20relationship%20drama%20theme%2C%20cinematic%20close-up%20shot%2C%20amber%20and%20deep%20red%20tones%2C%20emotional%20tension%2C%20editorial%20photography%20style&width=800&height=480&seq=article-cover-03&orientation=landscape',
    author: '聊天记录分析员',
    publishDate: '2026-07-04',
    readCount: 1560000,
    commentCount: 45200,
    likeCount: 112000,
    isHot: true,
    isFeatured: true,
    tags: ['聊天记录', '情侣博主', '分手内幕', '剧本演出'],
  },
  {
    id: 'article-4',
    title: '健身网红私下生活曝光：镜头前自律达人，镜头后暴饮暴食',
    excerpt: '以"自律改变人生"为口号的健身网红，被拍到私下大量摄入高热量食物并催吐的画面，反差之大令人瞠目结舌。其代言的多个健康品牌已紧急下架相关产品。',
    content: '',
    category: '反差视频',
    categorySlug: 'fancha-shipin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20split%20scene%20showing%20contrast%20between%20fitness%20model%20posing%20and%20junk%20food%20binge%2C%20dramatic%20lighting%20with%20warm%20amber%20tones%2C%20cinematic%20composition%2C%20dark%20moody%20atmosphere%2C%20editorial%20photography%20style%2C%20revealing%20duality%20concept&width=800&height=480&seq=article-cover-04&orientation=landscape',
    author: '反差追踪',
    publishDate: '2026-07-03',
    readCount: 789000,
    commentCount: 19800,
    likeCount: 43100,
    isHot: false,
    isFeatured: false,
    tags: ['反差视频', '健身网红', '人设崩塌', '代言下架'],
  },
  {
    id: 'article-5',
    title: '美妆博主直播间翻车现场，素颜出镜吓坏粉丝',
    excerpt: '知名美妆博主在直播时意外关闭美颜滤镜，真实容貌与平时精修照片差距巨大，直播间瞬间炸锅。该博主随后匆忙下播，至今未作出任何回应。',
    content: '',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20live%20streaming%20setup%20with%20beauty%20filter%20glitch%20effect%2C%20dramatic%20reveal%20moment%2C%20warm%20dramatic%20lighting%2C%20shocked%20reaction%20aesthetic%2C%20cinematic%20composition%2C%20dark%20moody%20atmosphere%2C%20amber%20and%20red%20tones%2C%20editorial%20style&width=800&height=480&seq=article-cover-05&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-07-02',
    readCount: 2100000,
    commentCount: 67800,
    likeCount: 156000,
    isHot: true,
    isFeatured: true,
    tags: ['网红塌房', '美妆博主', '直播翻车', '素颜'],
  },
  {
    id: 'article-6',
    title: '游戏主播代打事件升级：多名顶流主播被牵连',
    excerpt: '游戏圈代打丑闻持续发酵，继某头部主播被实锤后，又有三名百万粉丝级别的游戏主播被扒出代打证据。涉及的游戏包括多款热门竞技游戏，圈内震动。',
    content: '',
    category: '黑料大瓜',
    categorySlug: 'heiliao-dagua',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gaming%20setup%20with%20shadow%20figure%20behind%20the%20player%2C%20suggesting%20cheating%20or%20ghost%20playing%2C%20dramatic%20warm%20lighting%2C%20dark%20moody%20atmosphere%2C%20competitive%20gaming%20theme%2C%20cinematic%20composition%2C%20amber%20tones%2C%20editorial%20photography&width=800&height=480&seq=article-cover-06&orientation=landscape',
    author: '游戏圈观察员',
    publishDate: '2026-07-01',
    readCount: 672000,
    commentCount: 15600,
    likeCount: 37400,
    isHot: false,
    isFeatured: false,
    tags: ['黑料大瓜', '游戏主播', '代打', '竞技游戏'],
  },
  {
    id: 'article-7',
    title: '情感博主被扒已婚已育，单身人设全靠编',
    excerpt: '以"情感导师"身份走红、拥有八百万粉丝的情感博主，被网友扒出早已结婚并育有两个孩子。其所有"单身恋爱经验分享"都被证实为虚构剧本。',
    content: '',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20wedding%20ring%20hidden%20behind%20a%20social%20media%20phone%2C%20dramatic%20reveal%20concept%2C%20warm%20amber%20lighting%2C%20dark%20moody%20background%2C%20relationship%20deception%20theme%2C%20cinematic%20close-up%2C%20editorial%20photography%20style&width=800&height=480&seq=article-cover-07&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-06-30',
    readCount: 987000,
    commentCount: 23400,
    likeCount: 56700,
    isHot: true,
    isFeatured: false,
    tags: ['网红塌房', '情感博主', '已婚', '人设造假'],
  },
  {
    id: 'article-8',
    title: '爆料：某知名带货主播数据造假，实际成交率不足1%',
    excerpt: '内部人士爆料，某拥有千万粉丝的头部带货主播，其直播间看似火爆的数据背后，实际成交转化率不足1%。大量订单在直播结束后被批量取消。',
    content: '',
    category: '每日爆料',
    categorySlug: 'meiri-baoliao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20live%20streaming%20ecommerce%20scene%20with%20fake%20data%20charts%20in%20background%2C%20dramatic%20reveal%20of%20fraud%2C%20warm%20amber%20and%20red%20tones%2C%20dark%20moody%20atmosphere%2C%20cinematic%20composition%2C%20editorial%20photography%20style%2C%20high%20contrast&width=800&height=480&seq=article-cover-08&orientation=landscape',
    author: '电商数据调查',
    publishDate: '2026-06-29',
    readCount: 1340000,
    commentCount: 38900,
    likeCount: 87800,
    isHot: true,
    isFeatured: false,
    tags: ['每日爆料', '带货主播', '数据造假', '成交率'],
  },
  {
    id: 'article-9',
    title: '旅行博主"环游日记"被曝从未出过国，所有视频均为后期合成',
    excerpt: '以"环球旅行"走红的博主"环游日记"，被技术大神扒出其所有海外旅行视频均为绿幕拍摄加后期素材合成。博主本人实际从未离开过所在城市。',
    content: '',
    category: '反差视频',
    categorySlug: 'fancha-shipin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20green%20screen%20studio%20setup%20with%20fake%20travel%20background%20on%20monitor%2C%20revealing%20deception%2C%20dramatic%20warm%20lighting%2C%20dark%20moody%20atmosphere%2C%20cinematic%20composition%2C%20amber%20tones%2C%20editorial%20photography%20style%2C%20contrast&width=800&height=480&seq=article-cover-09&orientation=landscape',
    author: '技术解码组',
    publishDate: '2026-06-28',
    readCount: 890000,
    commentCount: 21200,
    likeCount: 49800,
    isHot: false,
    isFeatured: false,
    tags: ['反差视频', '旅行博主', '后期合成', '造假'],
  },
];